import { inputGroupNames } from "./CelinkFinancialModelStaticData";

export const defaultInputArrayValues = [
  {
    enable: false,
    input: inputGroupNames.PAndLExHUD,
    year: 2024,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLExHUD,
    year: 2025,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLExHUD,
    year: 2026,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLExHUD,
    year: 2027,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLExHUD,
    year: 2028,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLExHUD,
    year: 2029,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLHUD,
    year: 2024,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLHUD,
    year: 2025,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLHUD,
    year: 2026,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLHUD,
    year: 2027,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLHUD,
    year: 2028,
  },
  {
    enable: false,
    input: inputGroupNames.PAndLHUD,
    year: 2029,
  },
  {
    enable: false,
    input: inputGroupNames.Headcount,
    year: 2024,
  },
  {
    enable: false,
    input: inputGroupNames.Headcount,
    year: 2025,
  },
  {
    enable: false,
    input: inputGroupNames.Headcount,
    year: 2026,
  },
  {
    enable: false,
    input: inputGroupNames.Headcount,
    year: 2027,
  },
  {
    enable: false,
    input: inputGroupNames.Headcount,
    year: 2028,
  },
  {
    enable: false,
    input: inputGroupNames.Headcount,
    year: 2029,
  },
  {
    enable: false,
    input: inputGroupNames.NoTitle,
    year: 2024,
  },
  {
    enable: false,
    input: inputGroupNames.NoTitle,
    year: 2025,
  },
  {
    enable: false,
    input: inputGroupNames.NoTitle,
    year: 2026,
  },
  {
    enable: false,
    input: inputGroupNames.NoTitle,
    year: 2027,
  },
  {
    enable: false,
    input: inputGroupNames.NoTitle,
    year: 2028,
  },
  {
    enable: false,
    input: inputGroupNames.NoTitle,
    year: 2029,
  },
  {
    enable: false,
    input: inputGroupNames.Portfolio,
    year: 2024,
  },
  {
    enable: false,
    input: inputGroupNames.Portfolio,
    year: 2025,
  },
  {
    enable: false,
    input: inputGroupNames.Portfolio,
    year: 2026,
  },
  {
    enable: false,
    input: inputGroupNames.Portfolio,
    year: 2027,
  },
  {
    enable: false,
    input: inputGroupNames.Portfolio,
    year: 2028,
  },
  {
    enable: false,
    input: inputGroupNames.Portfolio,
    year: 2029,
  },
  {
    enable: false,
    input: inputGroupNames.WorkingCapital,
    year: 2024,
  },
  {
    enable: false,
    input: inputGroupNames.WorkingCapital,
    year: 2025,
  },
  {
    enable: false,
    input: inputGroupNames.WorkingCapital,
    year: 2026,
  },
  {
    enable: false,
    input: inputGroupNames.WorkingCapital,
    year: 2027,
  },
  {
    enable: false,
    input: inputGroupNames.WorkingCapital,
    year: 2028,
  },
  {
    enable: false,
    input: inputGroupNames.WorkingCapital,
    year: 2029,
  },
  {
    enable: false,
    input: inputGroupNames.Other,
    year: 2024,
  },
  {
    enable: false,
    input: inputGroupNames.Other,
    year: 2025,
  },
  {
    enable: false,
    input: inputGroupNames.Other,
    year: 2026,
  },
  {
    enable: false,
    input: inputGroupNames.Other,
    year: 2027,
  },
  {
    enable: false,
    input: inputGroupNames.Other,
    year: 2028,
  },
  {
    enable: false,
    input: inputGroupNames.Other,
    year: 2029,
  },
];
